/**
 * @generated SignedSource<<f91022550cbf6c8218d212a0c572fa71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbPricingGuidance_item" | "PdpRespSidebarBlurbReturnPolicy_item" | "PdpRespSidebarBlurbShipping_item" | "PdpSharedSidebarBuyerIncentives_item" | "useRenderBlurbs_item">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_item";
};
export type PdpRespSidebarBlurbs_item$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useRenderBlurbs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbReturnPolicy_item"
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarBlurbPricingGuidance_item"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSidebarBuyerIncentives_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "8d56d232c759e5ab3de57afd0f11c22a";

export default node;
